<div class="flex flex-col items-center wrapper">
  <div class="flex justify-center items-center loader-container">
    <mat-progress-spinner [color]="'warn'" [strokeWidth]="2" [value]="100" class="inner-stroke"></mat-progress-spinner>

    <mat-progress-spinner [strokeWidth]="2.1"
                          [value]="percent"
                          appCircularProgressBarGradient
                          class="outer-stroke">
    </mat-progress-spinner>

    <div [ngClass]="{'alert': metricInfo.hasError}" class="flex flex-col justify-center items-center inner-content">
      <img [src]="metricInfo.iconHref"/>
      <div class="white-fg mat-display-1 mb-30">{{metricInfo.text}}</div>
    </div>
  </div>
</div>
